export default __webpack_public_path__ + "static/media/userIcon.48d52cdc.png";